import { createRoute, Outlet, useRouterState } from '@tanstack/react-router'

import { activeNavigationItem } from '@/app/routes/area-layout'
import { SERVICE_ACCOUNT_PERMISSIONS } from '@/lib/permissions'
import { useSelectedEntity } from '@/modules/hierarchy'
import { LoadingNotice } from '@/ui/loading-notice'
import { RetryNotice } from '@/ui/retry-notice'

import { useUserManagementEntity } from './user-management-entity-queries'
import { LockedNotice } from './locked-notice'
import { accessRoute } from './access-route'

export function UserManagementScope() {
  const { entityId, entity } = useSelectedEntity()
  const destination = useRouterState({
    select: (state) => activeNavigationItem('access', state.matches.at(-1)?.fullPath),
  })
  const isServiceAccountRoute =
    destination?.permission === SERVICE_ACCOUNT_PERMISSIONS.read
  const userManagementEntity = useUserManagementEntity(
    isServiceAccountRoute ? null : entityId,
  )

  if (isServiceAccountRoute) return <Outlet />

  if (entityId !== null && userManagementEntity.status === 'loading')
    return <LoadingNotice message="Loading access…" />

  if (entityId !== null && userManagementEntity.status === 'error')
    return (
      <RetryNotice
        className="p-6"
        message={userManagementEntity.message}
        onRetry={userManagementEntity.retry}
      />
    )

  if (
    entityId !== null &&
    userManagementEntity.status === 'ready' &&
    !userManagementEntity.isUserManagementEntity
  )
    return (
      <LockedNotice
        entityName={entity.data?.name ?? 'This entity'}
        userManagementEntityId={userManagementEntity.userManagementEntityId}
        userManagementEntityName={userManagementEntity.userManagementEntityName}
        className="px-6 py-20"
      />
    )

  return <Outlet />
}

export const userManagementScopeRoute = createRoute({
  getParentRoute: () => accessRoute,
  id: 'user-management-scope',
  component: UserManagementScope,
})
